import React from 'react';
import { useParams } from 'react-router-dom';
// import ResultView from './ResultView';
import './ClientDashboard.css'; // Import the new CSS file

// Example mock data; ideally fetched via API
const clientData = {
  id: 'example',
  name: 'John Smith',
  program: 'Strength Training',
  nextSession: 'Tomorrow, 10:00 AM',
  goals: ['Bench 225 lbs', 'Lose 5% body fat', 'Improve mobility'],
  progress: [
    { date: '2025-06-01', note: 'Completed upper body session' },
    { date: '2025-05-28', note: 'Improved squat depth' },
    { date: '2025-05-25', note: 'Logged all meals' },
  ],
};

const ClientDashboard = () => {
  const { clientId } = useParams(); // If routed with /clients/:clientId
  const client = clientData; // In real app, filter or fetch based on clientId

  return (
    <div className="clientdashboard-container fogged-card">
      <h1 className="clientdashboard-title">Welcome, {client.name}</h1>

      <div className="clientdashboard-overview">
        <div className="clientdashboard-overview-card">
          <h3>Current Program</h3>
          <p>{client.program}</p>
        </div>
        <div className="clientdashboard-overview-card">
          <h3>Next Session</h3>
          <p>{client.nextSession}</p>
        </div>
      </div>

      <div className="clientdashboard-section">
        <h2>Your Goals</h2>
        <ul className="clientdashboard-goals-list">
          {client.goals.map((goal, idx) => (
            <li key={idx} className="clientdashboard-goal-item">{goal}</li>
          ))}
        </ul>
      </div>

      <div className="clientdashboard-section">
        <h2>Progress Log</h2>
        <ul className="clientdashboard-progress-log">
          {client.progress.map((entry, idx) => (
            <li key={idx} className="clientdashboard-progress-item">
              <strong>{entry.date}:</strong> {entry.note}
            </li>
          ))}
        </ul>
      </div>

      {/* <ResultView /> */}
    </div>
  );
};

export default ClientDashboard;
